<template>
    <pbc-overlay bgcolor='bg-gray-900'
               @done='goBack'
               @close='goBack'>
      <template #default='{done}'>

        <download-clips :id='postId' />

        <div class="grow justify-end flex flex-col">
          <div class="justify-end flex flex-row mt-2 mb-4">

            <pbc-share 
                      :url='shareUrl'
                      @success='shareSuccess'
                      @copied='shareCopy'
                      @error='shareError'
                      class='p-0 m-0 w-32 h-16'
                      title='My Meme'
                      text='Check out my post!'>
              <template #clickable='{busy,share}'>
                <div v-if='busy' class="mt-4 ml-4 spinner" />
                <button v-else class="download-clip-button h-12 w-32 pbc-primary-color" @click='share'>
                  <share-variant :size='32' />
                  Share
                </button>
              </template>
            </pbc-share>

            <button class="mx-4 flex-none h-12 w-32 download-clip-button pbc-primary-color" @click='done'>
              <check :size='32' />
              Done
            </button>

            <pbc-message ref='message' />
          </div>
        </div>
      </template>
    </pbc-overlay>
  
</template>
<script>
import ShareVariant from '@icons/ShareVariant.vue';
import Check from '@icons/Check.vue';
import PbcMessage from '@ui/molecules/PbcMessage.vue';
import PbcShare from '@ui/atoms/PbcShare.vue';
//import PbcPopup from '@ui/molecules/PbcPopup.vue';
import DownloadClips from '@ui/organisms/DownloadClips.vue';
export default {
  props:{
    postId:{
      type:String,
      required:true
    }
  },
  components:{
    DownloadClips,
    PbcShare,
    PbcMessage,
    ShareVariant,
    Check
    //PbcPopup
  },
  methods:{
    shareError() {
      this.$refs.message.show({
        type: 'error',
        title:'Something went wrong... try again.'
      });
    },
    shareSuccess() {
      this.$refs.message.show({
        title:'Link shared.'
      });
    },
    shareCopy() {
      this.$refs.message.show({
        title:'Link copied.'
      });
    },
    goBack() {
      this.$router.back();
    }
  },
  computed:{
    shareUrl() {
      if (process.browser) {
        return `https://${window.location.hostname}/post/${this.postId}`;
      } else {
        return `/post/${this.postId}`
      }
    },
  }
}
</script>
